import { Dispatch, SetStateAction } from 'react';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
} from 'components/ui/dialog';
import { Icon } from 'components/ui/icon';

interface IProps {
  status: boolean;
  showModal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

const STATUS_CONFIG = {
  online: {
    icon: 'check-circle' as const,
    iconColor: 'text-green-500',
    title: 'Device Online',
    description: 'The payment device is online.',
  },
  offline: {
    icon: 'alert-circle' as const,
    iconColor: 'text-yellow-500',
    title: 'Device Offline',
    description: 'The payment device is currently offline.',
  },
};

const DeviceStatus = ({
  status,
  setShowModal,
  showModal,
}: IProps): JSX.Element => {
  const config = status ? STATUS_CONFIG.online : STATUS_CONFIG.offline;

  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="max-w-sm" data-testid="device-status-modal">
        <div className="flex items-start gap-3">
          <Icon
            name={config.icon}
            size={32}
            className={config.iconColor}
            aria-hidden="true"
          />
          <div>
            <h1 className="mb-2 font-semibold text-gray-blue-90">
              {config.title}
            </h1>
            <span className="text-sm text-gray-blue-70">
              {config.description}
            </span>
          </div>
        </div>
        <DialogFooter className="flex justify-end">
          <Button
            data-testid="closeDeviceStatus"
            onClick={() => setShowModal(false)}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeviceStatus;
